import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {memo} from 'react';

const VerifyListItem = ({
  labelKey,
  value,
  children,
  className,
  fullView,
  dots,
  column,
  help,
  fullSpace,
  removeSpace,
  truncate,
  forceRow,
  boldTitle = false
}) => {
  return (
    <div
      className={classNames('flex',
        {'flex-col': !forceRow},
        {'flex-row items-center': forceRow},
        {'md:flex-row md:items-center': !column},
        {'flex-1': fullSpace},
        {'truncate': truncate},
        {'mb-4': !removeSpace}
      )}>
      <>
        <div
          className={classNames({'font-medium': boldTitle}, 'flex items-center mb-1', {'md:min-w-30': !fullView}, {'md:mb-0': !column}, className)}>
          {labelKey}{(labelKey && dots) && ':'}
        </div>
        {!!help && <div className="text-xs max-w-3/4">{help}</div>}
      </>
      <div
        title={value}
        className={classNames({'flex-1 w-full': fullSpace}, {'mb-1': !removeSpace}, {'self-start md:mb-0': !column}, {'truncate': truncate}, {'ml-2': (labelKey && !column) || forceRow})}>
        {value || children}
      </div>
    </div>
  );
};

VerifyListItem.propTypes = {
  labelKey: PropTypes.any,
  help: PropTypes.any,
  column: PropTypes.bool,
  boldTitle: PropTypes.bool,
  dots: PropTypes.bool,
  forceRow: PropTypes.bool,
  truncate: PropTypes.bool,
  fullView: PropTypes.bool,
  fullSpace: PropTypes.bool,
  removeSpace: PropTypes.bool,
  className: PropTypes.string,
  value: PropTypes.any,
  translate: PropTypes.string,
  children: PropTypes.any,
  onChange: PropTypes.func,
};

VerifyListItem.defaultProps = {
  dots: true
};

export default memo(VerifyListItem);
